exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hover:hover{cursor:pointer}.icici-logo{width:auto;height:30px}.consent-text{font-size:14px;margin-left:12px}.consent-wrapper{display:flex;justify-content:center;align-items:center;padding:0 20px}\n", ""]);

